import http from '../http';
import { type AxiosCompatibleResponse } from '../http/types';

import { type SimilarResponse } from './aliases';
import { type FetchSimilarItemsQueryParams } from './types';

import { SIMILAR_ITEMS_ENDPOINT } from '@/constants/endpoints';

export function fetchSimilarItems(
  productId: string,
  params?: FetchSimilarItemsQueryParams,
  withAuth?: boolean
): Promise<AxiosCompatibleResponse<SimilarResponse>> {
  return http.get(SIMILAR_ITEMS_ENDPOINT.replace(':productId', productId), {
    params,
    withAuth,
    withDeviceId: true,
  });
}
